<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="4"
      />

      <b-col
        cols="12"
        md="4"
      >
        <b-card>
          <template v-if="!submitted">
            <p class="mb-1">
              Enter your username or email address below and we will send you instructions for resetting your password.
            </p>

            <b-form @submit.prevent="submit">
              <b-form-group
                label="Search by"
              >
                <b-form-select
                  v-model="mode"
                  :options="modeOptions"
                />
              </b-form-group>

              <b-form-group
                v-if="mode === 'username'"
                label="Username"
              >
                <b-form-input
                  v-model="username"
                  required
                  autofocus
                />
              </b-form-group>

              <b-form-group
                v-else
                label="Email address"
              >
                <b-form-input
                  v-model="email"
                  type="email"
                  required
                  autofocus
                />
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                block
              >
                Send Reset Instructions
              </b-button>
            </b-form>
          </template>

          <template v-else>
            <p class="mb-0">
              If such a user is registered, you will shortly receive an email with instructions to reset your password.
            </p>
          </template>

          <div class="mt-2 text-center">
            <b-link @click="goBack">
              Back to login
            </b-link>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BForm, BFormGroup, BFormInput, BButton, BLink, BFormSelect,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BLink,
    BFormSelect,
  },
  data() {
    return {
      mode: 'username',
      username: '',
      email: '',
      submitted: false,
      modeOptions: [
        { value: 'username', text: 'Username' },
        { value: 'email', text: 'Email address' },
      ],
    }
  },
  activated() {
    this.mode = 'username'
    this.username = ''
    this.email = ''
    this.submitted = false
  },
  methods: {
    submit() {
      this.$http.post('public.cfc?method=checkForgottenPassword', new URLSearchParams({
        username: this.mode === 'username' ? this.username : '',
        emailname: this.mode === 'email' ? this.email : '',
      }))
        .then(() => {
          this.submitted = true
          this.username = ''
          this.email = ''
          this.$bvToast.toast('If an account exists with those details, you will receive a password reset email shortly', {
            title: 'Check your email',
            variant: 'success',
            solid: true,
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push({ name: 'login' })
      }
    },
  },
}
</script>
